/**
 * App Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress';
import router from '../../../router';
import api from '../../../api'
const state = {
    rooms: [],
    wallets: [],
    bvs: [],
    loading: false,
}

// getters
const getters = {
    getListRooms: state => {
        return state.rooms;
    },
}

// actions
const actions = {
    getAppData(context){
        context.dispatch('getListRooms')
        context.dispatch('getListWallets')
        context.dispatch('getListBvs')
    },
    async getListRooms(context) {
        let data = await api.getListRoom()
        if (data.status === 200){
            context.commit('rooms', data.data)
        } else {
            console.log('Không thể get list rooms');
        }
        return true
    },
    async getListWallets(context) {
        let data = await api.getListWallets()
        if (data.status === 200){
            context.commit('wallets', data.data)
        } else {
            console.log('Không thể get list wallets');
        }
        return true
    },
    async getListBvs(context) {
        let data = await api.getListBvs()
        if (data.status === 200){
            context.commit('bvs', data.data)
        } else {
            console.log('Không thể get list bvs');
        }
        return true
    },
}

// mutations
const mutations = {
    rooms(state, payload) {
        state.rooms = payload.slice(0)
    },
    wallets(state, payload){
        state.wallets = payload.slice(0)
    },
    bvs(state, payload){
        state.bvs = payload.slice(0)
    },
    loading(state, payload) {
        state.loading = payload
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
